const step_up = {
    verify_your_identity: '驗證您的身分',
    choose_method_description: '若要繼續，請使用以下任一方式確認是您本人。',
    password: '密碼',
    password_description: '輸入您的帳戶密碼',
    enter_password_description: '輸入您的帳戶密碼以繼續。',
    enter_verification_code_description: '輸入發送至 {{identifier}} 的驗證碼。',
    subject_proof_description: '若要繼續，請透過與您帳戶連結的另一個帳戶確認是您本人。之後即可設定驗證方式。',
    subject_mismatch: '帳號不相符',
    subject_mismatch_description: '你使用的帳號未連結到你的帳戶。請使用已連結的帳號；如有需要，請先在第三方服務商處切換帳號。',
    no_method_available: '沒有可用的驗證方式',
    no_method_available_description: '您的帳戶沒有可完成此驗證的方式。請聯絡您的管理員以取得協助。',
};
export default Object.freeze(step_up);
